

export const LIGHT_PURPLE = 0x7d83ad
export const COLOR_BACKGROUND = 0Xfaf3f3
export const NB_FISHES = 40

export const POND_SIZE = 8
const POND_LIMIT_BUFFER = 1
export const POND_SIZE_USABLE = POND_SIZE - 2 * POND_LIMIT_BUFFER



export const SIZES = {
    width: window.innerWidth,
    height: window.innerHeight
}